import { Constants, NUMBERS } from "./constants/commonConstants";

/**
 * Prevents invalid key presses for numeric input fields.
 * @param {KeyboardEvent} e - The keyboard event.
 */
export const preventInvalidNumericInput = (e) => {
  const isNonNumericKey = !/^\d$/.test(e.key) && e.key !== Constants.Backspace;
  const isLeadingZero = e.target.value == '' && e.key == NUMBERS.Zero;

  if (isNonNumericKey || isLeadingZero) {
    e.preventDefault();
  }
};